import { render, staticRenderFns } from "./GeneralProblem.vue?vue&type=template&id=267fd424"
import script from "./GeneralProblem.vue?vue&type=script&lang=ts"
export * from "./GeneralProblem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports